export default function Turn14PartnerCallout() {
    return (
        <s-paragraph color="subdued">
            For product imports, inventory and order automation, see{" "}
            <s-link href="https://apps.shopify.com/turn-14-distribution-api" target="_blank">Turn 14 Distribution by Data Here-to-There</s-link>.
        </s-paragraph>
    );
}
